module.exports = __webpack_public_path__ + "assets/img/box-4.94a7a411.png";